// src/components/common/GoogleLoginButton.jsx
import React from 'react';
import { auth, provider, signInWithPopup } from '../../firebase/config';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_BASE } from '../../config';
import './GoogleLoginButton.css';

const GoogleLoginButton = () => {
  const { refreshProfile, setTenant } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedPlan = new URLSearchParams(location.search).get('plan');

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const token = await user.getIdToken();

      const profile = await refreshProfile(token);
      if (!profile) throw new Error('Token verification failed');

      localStorage.setItem('vaultize_tenant_uid', profile.uid);

      const keyRes = await fetch(`${API_BASE}/dashboard/api-keys`, {
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => null);

      if (keyRes && keyRes.ok) {
        const keyData = await keyRes.json();
        const activeKey = Array.isArray(keyData) ? keyData.find(k => k.enabled) : null;
        if (activeKey && activeKey.apiKeyPreview) {
          localStorage.setItem('vaultize_api_key', activeKey.apiKeyPreview);
        }
      }

      setTenant && setTenant(profile);

      if (selectedPlan) {
        const checkoutRes = await fetch(`${API_BASE}/billing/stripe/checkout`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ plan: selectedPlan }),
        });

        const { url } = await checkoutRes.json();
        window.location.href = url;
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      console.error('Google login failed:', err);
      alert('Login failed. Please try again.');
    }
  };

  return (
    <button
      type="button"
      className="google-login-btn"
      onClick={handleLogin}
    >
      <span className="google-icon">G</span>
      Continue with Google
    </button>
  );
};

export default GoogleLoginButton;
